import { useEffect, useState } from "react";
import { Typography, CircularProgress } from "@mui/material";
import { CompletedJobDocumentType } from "@/lib/supabase/supabaseTypes";
import { Logger } from "@/lib/logger/Logger";

interface CalculatedAmountCellProps {
	jobDoc: CompletedJobDocumentType;
	calculateAmount: (jobDoc: CompletedJobDocumentType) => Promise<number>;
}

export const CalculatedAmountCell: React.FC<CalculatedAmountCellProps> = ({
	jobDoc,
	calculateAmount,
}) => {
	const [amount, setAmount] = useState<number | null>(null);
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<boolean>(false);

	useEffect(() => {
		const fetchAmount = async () => {
			setLoading(true);
			setError(false);
			try {
				const calculatedAmount = await calculateAmount(jobDoc);
				setAmount(calculatedAmount);
			} catch (err) {
				Logger.error("Error calculating amount:"+ err);
				setError(true);
			} finally {
				setLoading(false);
			}
		};

		fetchAmount();
	}, [jobDoc]);

	if (loading) {
		return (
			<div className="flex items-center gap-2">
				<CircularProgress size={16} />
				<Typography variant="body2" color="text.secondary">
					Berechnet...
				</Typography>
			</div>
		);
	}

	if (error) {
		return (
			<Typography variant="body2" color="error">
				Fehler
			</Typography>
		);
	}

	return (
		<Typography variant="body2" color="success.main" fontWeight="medium">
			CHF {amount?.toFixed(2) || "0.00"}
		</Typography>
	);
};